import { SnackbarProvider, MaterialDesignContent, closeSnackbar } from 'notistack';
import { styled, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent': {
    fontSize: '1rem !important',
    backgroundColor: '#000000E3 !important',
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: '#000000E3 !important',
  },
  '&.notistack-MuiContent-success': {
    backgroundColor: '#226453 !important',
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#A72A2A !important',
  },
}));

export default function SnackbarProviderContainer({ children }) {
  return (
    <SnackbarProvider
      maxSnack={5}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      action={(snackbarId) => (
        <IconButton
          aria-label="Close notification"
          size="small"
          onClick={() => closeSnackbar(snackbarId)}
        >
          <CloseIcon fontSize="small" sx={{ color: 'white' }} />
        </IconButton>
      )}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        default: StyledMaterialDesignContent,
      }}
    >
      {children}
    </SnackbarProvider>
  );
}
